module.exports = __webpack_public_path__ + "static/media/education.915dbc4c.svg";